export default {
  "config": {
    "trial": "driving",
    "id": "baseline-char",
    "type": "table",
    "title": "Demographic and Baseline Clinical Characteristics<sup>29</sup>",
    "footnotes": [],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "driving",
    "id": "baseline-char",
    "data-type": "table",
    "title": "Demographic and Baseline Clinical Characteristics<sup>29</sup>",
    "num-header-rows": 1,
    "num-columns": 2,
    "col-classes": [
      "col-1",
      "total"
    ],
    "row-mergeoption": [
      1
    ],
    "data": {
      "row-0": [
        {
          "indent": 0,
          "content": "<b>Characteristic</b>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<b>Total <no-break>(N = 34)</no-break></b>",
          "cols": 1,
          "class": "total"
        }
      ],
      "row-1": [
        {
          "indent": 0,
          "content": "Age, years, <no-break>mean ± SD</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>51.6 ± 12.3</no-break>",
          "cols": 1,
          "class": "total"
        }
      ],
      "row-2": [
        {
          "indent": 0,
          "content": "Male, <no-break>n (%)</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>30 (88)</no-break>",
          "cols": 1,
          "class": "total"
        }
      ],
      "row-3": [
        {
          "indent": 0,
          "content": "BMI, kg/m<sup>2</sup>, <no-break>mean ± SD</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>29.3 ± 3.9</no-break>",
          "cols": 1,
          "class": "total"
        }
      ],
      "row-4": [
        {
          "indent": 0,
          "content": "Use of a primary OSA therapy, <no-break>n (%)</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>29 (85)</no-break>",
          "cols": 1,
          "class": "total"
        }
      ],
      "row-5": [
        {
          "indent": 0,
          "content": "History of surgical intervention for OSA symptoms, <no-break>n (%)</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>10 (29)</no-break>",
          "cols": 1,
          "class": "total"
        }
      ],
      "row-6": [
        {
          "indent": 0,
          "content": "Mean MWT sleep latency, min, <no-break>mean ± SD</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>14.3 ± 7.3</no-break>",
          "cols": 1,
          "class": "total"
        }
      ],
      "row-7": [
        {
          "indent": 0,
          "content": "ESS total score, <no-break>mean ± SD</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>14.4 ± 3.5</no-break>",
          "cols": 1,
          "class": "total"
        }
      ],
      "row-8": [
        {
          "indent": 0,
          "content": "THAT total score, <no-break>mean ± SD</no-break> <no-break>(n = 29)</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>26.0 ± 7.6</no-break>",
          "cols": 1,
          "class": "total"
        }
      ]
    }
  }
};